import React, { useState } from 'react';
import SweetAlert from "react-bootstrap-sweetalert";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button } from "reactstrap";
import { cancelAllTasksWorkstations } from "../../store/actions";



const CancelTasksWorkstation= function(props){
    let ws=props.ws
    const [showAlert,setShowAlert] = useState(false)
    let user=JSON.parse(localStorage.getItem("authUser"))

    const cancelTasks=()=>{
    
        props.cancelAllTasksWorkstations(ws,user.token,props.history)
    }
    const noCancelTasks=()=>{
        setShowAlert(false)
    }
    const pressButton=(event)=>{
        event.preventDefault()
        setShowAlert(true)
    }
  
    return(
        <React.Fragment>
            <Button className="btn btn-danger waves-effect waves-light buttonStatus wsButton" onClick={(event)=>pressButton(event)}>  <i className="bx bx-block font-size-16 align-middle mr-2"></i>{" "}{props.t("Tareas")}</Button>
            {showAlert &&(
                <SweetAlert
                title= { props.t("¿Está seguro? ")}
             
                warning
              
                showCancel
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                cancelBtnText={props.t("cancel")}
                confirmBtnText={props.t("ok")}
                onConfirm={() => cancelTasks()}
                onCancel={()=>noCancelTasks()}
              >
                 {props.t("Va a cancelar todas las tareas")}
                 <br/>
                 {props.t("de la estación de trabajo ") +ws}
              </SweetAlert>
            
          ) }

        </React.Fragment>
    )
}


const mapStateProps = (state) => {
   
    const {  loadingCancelAllTasksWs} = state.CancelAllTasksWorkstation;
    
    return { loadingCancelAllTasksWs};
  };
  
export default withRouter(
    connect(mapStateProps, {
        cancelAllTasksWorkstations
    })(withNamespaces()(CancelTasksWorkstation))
  );